import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getRequest, postRequest } from '../../app/request';
import { failurePut } from '../../app/failurePut';
import {
    switchWithdrawalTransferStatusAction,
    getPayoutAvailableMethodsAction,
    getPayoutAvailableMethodsFailure,
    getPayoutAvailableMethodsSuccess,
    getPayoutFormAction,
    getPayoutFormFailure,
    getPayoutFormSuccess,
    getPayoutParamsAction,
    getPayoutParamsFailure,
    getPayoutParamsSuccess,
    payoutCancelAction,
    payoutCancelFailure,
    payoutCancelSuccess,
    payoutCreateAction,
    payoutCreateFailure,
    payoutCreateSuccess,
    setWithdrawalTransferParamsAction,
    withdrawalInitAction,
    withdrawalInitSuccess,
} from './withdrawalReducer';
import {
    IPayoutAvailableMethods,
    IPayoutCancelSuccessPayload,
    IPayoutCreateResponse,
    IPayoutParams,
    IWithdrawalTransferParams,
} from './withdrawal.t';
import { getWithdrawalError, getWithdrawalTransferParams } from './withdrawalSelectors';
import { WITHDRAWAL_TRANSFER_STATUS } from './withdrawalConstants';
import { appInitAction } from '../../app/appActions';
import { STATE_TX } from "../Account/components/TransactionHistory/transactionHistoryConstants";
import { IPaymentForm } from "../Payment/payment.t";

export function* getPayoutParamsSaga() {
    try {
        const data: IPayoutParams = yield call(getRequest, '/payout');

        yield put(getPayoutParamsSuccess(data));
    } catch (e: any) {
        yield call(failurePut, e, getPayoutParamsFailure);
    }
}

export function* withdrawalInitSaga() {
    yield call(getPayoutParamsSaga);
    yield put(withdrawalInitSuccess());
}

export function* payoutGetAvailableMethodsSaga({ payload }: ReturnType<typeof getPayoutAvailableMethodsAction>) {
    try {
        const data: IPayoutAvailableMethods = yield call(postRequest, '/payout/available_methods', {
            country: payload.country,
        });

        if (!data.length) {
            console.error('available_methods not found');
        }
        yield put(getPayoutAvailableMethodsSuccess(data));
    } catch (e: any) {
        yield call(failurePut, e, getPayoutAvailableMethodsFailure);
    }
}

export function* getPayoutFormSaga({ payload }: ReturnType<typeof getPayoutFormAction>) {
    try {
        const data: IPaymentForm = yield call(getRequest, `/payout/form?payment=${payload.payment}`);

        yield put(getPayoutFormSuccess(data));
    } catch (e: any) {
        yield call(failurePut, e, getPayoutFormFailure);
    }
}

export function* payoutCreateSaga({ payload }: ReturnType<typeof payoutCreateAction>) {
    const { body } = payload;
    try {
        const data: IPayoutCreateResponse = yield call(postRequest, '/payout/create', body);

        yield put(payoutCreateSuccess({
            amount: body.amount,
            isAuto: data.auto,
            transactionUuid: data.uuid,
        }));
    } catch (e: any) {
        yield call(failurePut, e, payoutCreateFailure);
    }
}

export function* payoutCancelSaga({ payload }: ReturnType<typeof payoutCancelAction>) {
    const { uuid, callback } = payload;
    try {
        const data: IPayoutCancelSuccessPayload = yield call(postRequest, '/payout/cancel', { uuid });
        yield put(payoutCancelSuccess(data));
        if (callback) {
            callback();
        }
        yield put(appInitAction());
    } catch (e: any) {
        yield call(failurePut, e, payoutCancelFailure);
    }
}

export function* switchWithdrawalTransferStatusSaga() {
    const transferParams: IWithdrawalTransferParams = yield select(getWithdrawalTransferParams);
    const withdrawalError = yield select(getWithdrawalError);
    const newWithdrawalTransferStatus =
        transferParams.transactionState === STATE_TX.ERROR || withdrawalError
            ? WITHDRAWAL_TRANSFER_STATUS.FAILURE
            : transferParams.transactionState === STATE_TX.COMPLETED
                ? WITHDRAWAL_TRANSFER_STATUS.SUCCESS
                : WITHDRAWAL_TRANSFER_STATUS.PENDING

    yield put(setWithdrawalTransferParamsAction({ status: newWithdrawalTransferStatus }));
}

export function* withdrawalSagas() {
    yield takeEvery(withdrawalInitAction, withdrawalInitSaga);
    yield takeEvery(getPayoutAvailableMethodsAction, payoutGetAvailableMethodsSaga);
    yield takeEvery(getPayoutFormAction, getPayoutFormSaga);
    yield takeEvery(getPayoutParamsAction, getPayoutParamsSaga);
    yield takeEvery(payoutCreateAction, payoutCreateSaga);
    yield takeEvery(payoutCancelAction, payoutCancelSaga);
    yield takeEvery(switchWithdrawalTransferStatusAction, switchWithdrawalTransferStatusSaga);
}
